module.exports = __webpack_public_path__ + "static/media/print-sgombero-detail4.b0cc96a7.jpg";